export { default } from './ReviewSnippetJsonLD';
